import { ui } from '@beelday/common'
import { GrowthColumnContainer } from 'common/presentation/containers'
import { RootState } from 'common/redux'
import { TrainingRoomPhase } from 'common/types'
import { useQuestions, VotingModal } from 'features/questions'
import { setIsExpandableCompanyCard } from 'organization/redux'
import { FC } from 'react'
import { use100vh } from 'react-div-100vh'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorWithStreams } from 'room/common/error-with-streams'
import { RoomContainer } from 'room/common/presentation/room-container'
import RoomHeader from 'room/common/presentation/room-header'
import { VideoLayoutResolver } from 'room/common/presentation/video-layout/video-layout-resolver'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import { useAssertedWorkflowUser } from 'room/common/use-workflow-user'
import { MiscPanel } from 'room/misc'
import ConfiguredReviewTask from 'room/training-room/review-tasks/configured-review-trainee'
import { SelectGroupPanelTraineeRedux } from 'room/training-room/set-groups/select-group-panel-trainee'
import { RecordingIndicator } from 'features/recording/recording-indicator'
import { TraineeMenu } from 'room/training-room/trainee-menu'
import { TrainerStreamView } from 'video-conference-media/presentation/top-right-stream-view'
import { VideoGrid } from 'video-conference-media/presentation/video-grid'
import { allStreams, endUserStreams } from 'video-conference-media/redux'
import { selectFocusedFeature } from './redux'
import { TraineeFocusedFeature } from './trainee-focused-feature'

export const RoomTrainee: FC = () => {
	const allSceneVideoUsers = useSelector(allStreams)
	const endUserSceneVideoUsers = useSelector(endUserStreams)
	const containerHeight = use100vh()
	const roomAddress = useAssertedJoinedRoomAddress()
	const user = useAssertedWorkflowUser()
	const dispatch = useDispatch()
	const trainingRoomPhase = useSelector(
		(state: RootState) => state.room.trainingRoomPhase
	)
	dispatch(setIsExpandableCompanyCard(false))
	const focusedFeature = useSelector(selectFocusedFeature)
	const questions = useQuestions()

	const showingFocusedFeature =
		focusedFeature && trainingRoomPhase === TrainingRoomPhase.INITIAL
	const trainerInPopup =
		focusedFeature || trainingRoomPhase === TrainingRoomPhase.REVIEWING_TASKS

	const streams = trainerInPopup ? endUserSceneVideoUsers : allSceneVideoUsers

	return (
		<RoomContainer
			style={{
				height: `${containerHeight}px`,
			}}
		>
			<RoomHeader
				streamView={trainerInPopup ? <TrainerStreamView startVisible /> : null}
			/>

			{showingFocusedFeature ? (
				<>
					<VideoLayoutResolver
						focusedFeature={focusedFeature.type}
						presenterStyle="distinguished"
						streams={streams}
					>
						<TraineeFocusedFeature streams={streams} />
					</VideoLayoutResolver>
					<TraineeMenu />
				</>
			) : (
				(() => {
					switch (trainingRoomPhase) {
						case TrainingRoomPhase.INITIAL:
							return (
								<>
									{showingFocusedFeature ? (
										<VideoLayoutResolver
											focusedFeature={focusedFeature.type}
											presenterStyle="distinguished"
											streams={streams}
										>
											<TraineeFocusedFeature streams={streams} />
										</VideoLayoutResolver>
									) : (
										<>
											{questions.active && (
												<VotingModal roomAddress={roomAddress} me={user.id} />
											)}
											<VideoGrid
												sceneVideoUsers={streams}
												presenterStyle="spotlight"
											/>
										</>
									)}
									<TraineeMenu />
								</>
							)
						case TrainingRoomPhase.REVIEWING_TASKS:
							return <ConfiguredReviewTask />
						case TrainingRoomPhase.SELECTING_GROUPS:
							return (
								<>
									<GrowthColumnContainer>
										<SelectGroupPanelTraineeRedux />
									</GrowthColumnContainer>
									<TraineeMenu />
								</>
							)
						default:
							return <ErrorWithStreams />
					}
				})()
			)}
			<RecordingIndicator />
			<MiscPanel />
			<ui.BeeldayLogoAbsoluteBottom />
		</RoomContainer>
	)
}
